import { defineComponent as _defineComponent } from 'vue'
import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'
  import useCourse from '@/composables/useCourse'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ContactMe',
  setup(__props) {

  const { michaelPortrait } = useIcons()
  const { isDesktopDevice } = useBreakpoint()
  const { contactEmail } = useCourse()

return { __sfc: true,michaelPortrait, isDesktopDevice, contactEmail, useIcons, useBreakpoint, useCourse }
}

})